export class KycSessionStorage {
  static setDataForSession<T>(sessionId: string, data: T): void {
    localStorage.setItem(`session_${sessionId}`, JSON.stringify(data || {}));
  }

  static getDataForSession<T>(sessionId: string): T {
    const sessionData = JSON.parse(localStorage.getItem(`session_${sessionId}`) || '{}');
    return sessionData as T;
  }

  static updateDataForSession<T>(sessionId: string, data: Partial<T>) {
    const current = this.getDataForSession<T>(sessionId) as any; //eslint-disable-line @typescript-eslint/no-explicit-any
    const merged = Object.assign(current, data);
    this.setDataForSession(sessionId, merged);
  }
}
